import { Box, Container, Flex } from '@chakra-ui/react'
import ProgressStepper from '../../../components/ProgressStepper'
import React from 'react'
import { useFormik } from 'formik'
import { signinSchema } from '../../../validations/signup'
import FormInput from '../../../components/Input'
import DisplaySwitcher from '../../../components/DisplaySwitch'
import DefaultButton from '../../../components/Button/Button'
import { endpoints, postFunc } from '../../../api'
import { showToast } from '../../../utils/toast'
import { Link, useNavigate } from 'react-router-dom'
import ProgressStepperBar from '../../../components/ProgressStepperBar'
import { steps } from '../../../constants/signup'
import useAuth from '../../../hooks/useAuth'
import SafeltoShortLogo from '../../../assets/icons/SafeltoShortLogo'
import LightSafeltoLogo from '../../../assets/icons/LightSafeltoLogo'
import useDevTokenGate from '../../../hooks/useDevTokenGate'
import Metadata from '../../../components/Metadata'
import ResidentPwaNotice from '../../../components/ResidentPwaNotice'

type signupDataType = {
  firstName: string
  lastName: string
  name: string
  email: string
  password: string
  // estateName: string;
  // estateAddress: string;
  address: string
  phone: string
  confirmPassword: string
}

interface SignupResponse {
  message: string
}


  const signupMetadata = {
    title: 'Signup - Safelto',
    description: 'Create a Safelto account to manage your estate, residents, and staff. Secure signup for property management platform.',
    keywords: ['signup', 'Safelto signup', 'property management signup', 'estate management signup'],
    image: '/assets/images/safelto-big.png',
    url: 'https://safelto.com/signup',
    type: 'website' as 'website'
  }

  const Signup = () => {
    useAuth({ to: '/auth/login' })
    const [step, setStep] = React.useState(1)
    const [loading, setLoading] = React.useState(false)
    const navigate = useNavigate()
    // allow users who are invited to sign up
    // useDevTokenGate()

    const initialValues: signupDataType = {
      firstName: '',
      lastName: '',
      name: '',
      email: '',
      password: '',
      // estateName: "",
      // estateAddress: "",
      address: '',
      phone: '',
      confirmPassword: '',
    }
    const submitForm = async (values: signupDataType) => {
      try {
        const data = await postFunc<Partial<signupDataType>, SignupResponse>(endpoints.register, {
          firstName: values.firstName,
          lastName: values.lastName,
          name: `${values.firstName} ${values.lastName}`,
          email: values.email,
          password: values.password,
          // estateName: values.estateName,
          // estateAddress: values.estateAddress,
          address: values.address,
          phone: values.phone,
        })
        showToast({
          id: 'register-successful-toast',
          title: data.message,
          description: 'Check your email to verify your account.',
          status: 'success',
        })
        setTimeout(() => {
          navigate('/auth/login', {
            replace: true,
          })
        }, 3000)
      } catch (err: any) {
        showToast({
          id: 'register-error-toast',
          title: err.message,
          status: 'error',
        })
      } finally {
        setLoading(false)
      }
    }

    const formik = useFormik({
      initialValues,
      validationSchema: signinSchema,
      onSubmit: () => {},
    })

    const increaseStep = () => {
      if (step >= steps.length) {
        return setStep(steps.length)
      }
      setStep(step + 1)
    }

    const decreaseStep = () => {
      if (step <= 1) {
        return setStep(1)
      }
      setStep(step - 1)
    }

    const selectStep = (selectedStep: number) => {
      if (selectedStep < 1 || selectedStep > steps.length) {
        return setStep(step)
      }
      setStep(selectedStep)
    }

    const stepValidator = () => {
      switch (step) {
        case 1:
          formik.validateField('firstName')
          formik.validateField('lastName')
          formik.validateField('email')
          formik.validateField('address')
          formik.validateField('phone')
          break
        case 2:
          formik.validateField('confirmPassword')
          formik.validateField('password')
          break
        default:
          break
      }
      return formik.errors
    }

    const stepError = () => {
      const {
        address,
        confirmPassword,
        email,
        // estateAddress,
        // estateName,
        firstName,
        lastName,
        password,
        phone,
      } = formik.errors
      switch (step) {
        case 1:
          return !!firstName || !!lastName || !!email || !!address || !!phone
        case 2:
          return !!confirmPassword || !!password
        default:
          break
      }
    }

    const handleStepper = async () => {
      if (loading) {
        return
      }

      stepValidator()
      if (!formik.dirty) {
        return
      }

      if (stepError()) {
        return
      }

      setLoading(true)

      if (step < steps.length) {
        increaseStep()
        setLoading(false)
      } else if (step === steps.length) {
        const formikError = await formik.validateForm()
        if (Object.values(formikError).length) {
          setLoading(false)
          return formikError
        }

        return submitForm(formik.values)
      }
    }


    return (
      <Flex flexBasis="" w={'full'}>
        <Metadata {...signupMetadata} />
      <div className="min-h-screen bg-black w-3/5 lg:w-[634px] p-10  text-white hidden lg:block">
        <LightSafeltoLogo />
        <div className="mt-[140px]">
          <ProgressStepper
            steps={steps}
            currentStep={step}
            orientation="vertical"
            height="238px"
            onStepChange={(step) => selectStep(step)}
          />
        </div>
      </div>
      <Box
        minH="100vh"
        bg="white"
        p={{ base: 4, md: 10 }}
        flexGrow="4"
        justifyContent="center"
        alignItems="center"
          position="relative" 
      >
        {step > 1 && (
  <button
    onClick={decreaseStep}
    className="absolute top-6 left-6 flex items-center gap-2 text-gray-600 hover:text-black transition-colors"
    aria-label="Go back"
  >
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="text-gray-600"
    >
      <path
        d="M15 18L9 12L15 6"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
    <span className="text-sm font-medium">Back</span>
  </button>
)
}

        <div className="flex flex-col min-h-[90vh] space-y-10  ">
          <Container margin="auto" width="full" maxW="474px" px="0">
            <div>
              {step === 1 && (
                <ResidentPwaNotice
                  className="mb-8"
                  message="This sign-up is for estate managers. Are you a resident?"
                  linkText="Create your account in Safelto Resident"
                  path="/register"
                />
              )}
              {/* <img src={SafeltoShortLogo} className="w-10 h-10 mx-auto" alt="Logo" /> */}
              <div className="w-10 h-10 mx-auto">
                <SafeltoShortLogo />
              </div>
              <div className="text-center my-10">
                <div className="font-bold text-[16px] leading-7">
                  {steps[step - 1].title}
                </div>
                <div className="font-medium text-[#ADB5BD]">
                  {steps[step - 1].description}
                </div>
              </div>
              <DisplaySwitcher
                displayList={[
                  // <>
                  //   <FormInput
                  //     placeholder="Enter estate name"
                  //     size="lg"
                  //     variant="outline"
                  //     value={formik.values.estateName}
                  //     onChange={formik.handleChange}
                  //     name="estateName"
                  //     error={formik.errors.estateName}
                  //   />
                  //   <FormInput
                  //     placeholder="Enter estate address"
                  //     size="lg"
                  //     variant="outline"
                  //     value={formik.values.estateAddress}
                  //     onChange={formik.handleChange}
                  //     name="estateAddress"
                  //     error={formik.errors.estateAddress}
                  //   />
                  // </>,
                  <div className="space-y-10 my-[40px]">
                    <FormInput
                      placeholder="Enter your First name"
                      size="md"
                      variant="outline"
                      value={formik.values.firstName}
                      onChange={formik.handleChange}
                      name="firstName"
                      error={formik.errors.firstName}
                    />
                    <FormInput
                      placeholder="Enter your Last name"
                      size="md"
                      variant="outline"
                      value={formik.values.lastName}
                      onChange={formik.handleChange}
                      name="lastName"
                      error={formik.errors.lastName}
                    />
                    <FormInput
                      placeholder="Enter your phone number"
                      size="md"
                      variant="outline"
                      value={formik.values.phone}
                      onChange={formik.handleChange}
                      name="phone"
                      error={formik.errors.phone}
                    />
                    <FormInput
                      placeholder="Enter your email address"
                      size="md"
                      variant="outline"
                      value={formik.values.email}
                      onChange={formik.handleChange}
                      name="email"
                      error={formik.errors.email}
                    />
                    <FormInput
                      placeholder="Enter your address"
                      size="md"
                      variant="outline"
                      value={formik.values.address}
                      onChange={formik.handleChange}
                      name="address"
                      error={formik.errors.address}
                    />
                  </div>,
                  <div className="space-y-8">
                    <FormInput
                      value={formik.values.password}
                      onChange={formik.handleChange}
                      name={'password'}
                      placeholder="Enter password"
                      error={formik.errors.password}
                      type="password"
                      useToggle={true}
                      size="md"
                    />
                    <FormInput
                      value={formik.values.confirmPassword}
                      onChange={formik.handleChange}
                      name={'confirmPassword'}
                      placeholder="Re-enter password"
                      error={formik.errors.confirmPassword}
                      type="password"
                      useToggle={true}
                      size="md"
                    />
                  </div>,
                ]}
                currentStep={step}
              />

              <DefaultButton
                bg="black"
                loading={loading}
                loadingText={step === steps.length ? 'Submitting...' : 'Loading...'}
                color="white"
                size="lg"
                className="w-full mt-[40px]"
                onClick={handleStepper}
                disabled={loading}
                style={{
                  backgroundColor: formik.dirty ? 'black' : '#DEE2E6',
                }}
              >
                {step === steps.length ? 'Register' : 'Continue'}
              </DefaultButton>

              {step > 1 && (
                <DefaultButton
                  onClick={decreaseStep}
                  hideFrom="1024px"
                  className="w-full mt-[40px] bg-[#000] text-[#fff] hover:bg-[#CED4DA]"
                  border="1px solid"
                  borderColor="gray.300"
                  size="md"
                  _hover={{ border: 'none' }}
                >
                  Back
                </DefaultButton>
              )}

              <div className="text-center py-[20px]">
                <div>
                  Have an account?{' '}
                  <Link to={'/auth/login'} className="text-blue-400">
                    Login
                  </Link>
                </div>
              </div>
            </div>
          </Container>

          <div className="flex justify-center">
            <ProgressStepperBar currentStep={step} stepCount={steps.length} />
          </div>
        </div>
      </Box>
    </Flex>
  )
}

export default Signup
